const answerStyle =
  'f3 pointer dt-white tc pv3 mt2 bg-animate bg-navy bn ti-sans-b ttu noselect';
const uncenteredAnswerStyle = 'f4 pointer pt2 mt2 bg-animate bg-navy';

const unselectedAnswerStyle = `${answerStyle}`;
const selectedAnswerStyle = `${answerStyle} bg-dt-blue navy`;
// const uncenteredUnselectedAnswerStyle = `${uncenteredAnswerStyle} dt-white`;
// const uncenteredSelectedAnswerStyle = `${uncenteredAnswerStyle} bg-dt-blue dt-white`;

const stickToBottom = 'stickToBottom mw8-ns absolute w-100 bottom-0';
const stickToBottomZ = 'absolute relative-l w-100 bottom-0 z--1';

const bgAnswer = 'bg-dt-white ba bw3';
const bgCorrectAnswer = `${bgAnswer} b--dt-blue`;
const bgWrongAnswer = `${bgAnswer} b--dt-red`;

const textAnswer = 'ml2 ti-sans-b ttu';
const textCorrectAnswer = `${textAnswer} dt-blue`;
const textWrongAnswer = `${textAnswer} dt-red`;

const uncenteredUnselectedAnswerStyle = `${bgAnswer} b--navy`;
const uncenteredSelectedAnswerStyle = `${bgAnswer} b--dt-blue`;

const questionTextStyle = 'f2-l f4-m f5 ti-sans pb4';

module.exports = {
  unselectedAnswerStyle,
  selectedAnswerStyle,
  uncenteredUnselectedAnswerStyle,
  uncenteredSelectedAnswerStyle,
  stickToBottom,
  stickToBottomZ,
  bgCorrectAnswer,
  bgWrongAnswer,
  textAnswer,
  textCorrectAnswer,
  textWrongAnswer,
  questionTextStyle
};
